import React from 'react'
import {Tag} from "antd";
import {useTranslations} from "../../lang";

export default function OrderStatusLabel({status}) {
    const {translate} = useTranslations();
    
    const statusLabels = {
        pending: translate("In afwachting"),
        paid: translate("Betaald"),
        handled: translate("Afgehandeld"),
        cancelled: translate("Geannuleerd"),
        completed: translate("Uitbetaald"),
        refunded: translate("Terugbetaald"),
        failed: translate("Mislukt")
    };

    const statusColors = {
        pending: "orange",
        paid: "green",
        cancelled: "red",
        handled: "cyan",
        refunded: "purple",
        completed: "blue",
        failed: "volcano"
    };


    return (
        <Tag color={
            statusColors[status] || "default"
        }>
            {statusLabels[status] || translate("Onbekende status")}
        </Tag>
    );
}